export default {
    login: {
        name: 'login',
        path: '/login',
        meta: { requiresAuth: false, public: true },
    },
    loginOld: {
        name: 'login-old',
        path: '/login/old',
        meta: { requiresAuth: false, public: true },
    },
    loginSignIn: {
        name: 'login-sing-in',
        path: '/login/sing-in',
        meta: { requiresAuth: false, public: true },
    },
    loginPinIn: {
        name: 'login-pin-in',
        path: '/login/pin-in',
        meta: { requiresAuth: false, public: true },
    },
    loginPinUp: {
        name: 'login-pin-up',
        path: '/login/pin-up',
        meta: { requiresAuth: false, public: true },
    },
    loginSignInVerifyEmail: {
        name: 'login-sing-in-verify-email',
        path: '/login/sing-in/verify-email',
        meta: { requiresAuth: false, public: true },
    },
    loginSignInVerifySms: {
        name: 'login-sing-in-verify-sms',
        path: '/login/sing-in/verify-sms',
        meta: { requiresAuth: false, public: true },
    },
    forgot: {
        name: 'forgot',
        path: '/forgot',
        meta: { requiresAuth: false, public: true },
    },
    forgotVerify: {
        name: 'forgot-verify',
        path: '/forgot/verify',
        meta: { requiresAuth: false, public: true },
    },
    forgotPasswordUp: {
        name: 'forgot-password-up',
        path: '/forgot/password-up',
        meta: { requiresAuth: false, public: true },
    },
    changePassword: {
        name: 'change-password',
        path: '/change/password',
        meta: { requiresAuth: false, public: true },
    },
};
